<a class="col text-decoration-none" routerLink="planJourney">
    <div class="border-card text-start d-flex align-items-center p-3 ps-0 ride-card">
        <div class="me-3">
            <img src="assets/images/car-share.png" alt="Red car" style="width: 80px;" />
        </div>

        <div class="flex-grow-1">
            <div class="d-flex flex-row justify-content-between">
                <h5 class="mb-1 ride-text">
                    Share the ride,<br>
                    share the joy
                </h5>
                <img src="assets/images/arrow.svg" style="width: 16px;">
            </div>
            <p class="mb-0" style="font-size: 0.9rem; color: #7e0034; font-weight: 200;">
                Find people nearby and turn the journey into part of the celebration.
            </p>
        </div>
    </div>
</a>